import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/shared/auth";
import talkjs from "./modules/b2b/talkjs";
import vehicleIdentification from "./modules/shared/vehicleIdentification";
import budget from "./modules/b2b/budget";
import techInfo from "./modules/b2b/techInfo";
import loadings from "./modules/shared/loadings";
import tyres from "./modules/b2b/tyres";
import customer from "./modules/b2b/customer";
import backofficeEntities from "./modules/backoffice/backofficeEntities";
import backofficeModulesDropdown from "./modules/backoffice/backofficeModulesDropdown";
import backofficeCalendarHoursDropdown from "./modules/backoffice/backofficeCalendarHoursDropdown";
import backofficeScheduling from "./modules/backoffice/backofficeScheduling";
import backofficeLastUser from "./modules/backoffice/backofficeLastUser";
import backofficeNavigation from "./modules/backoffice/backofficeNavigation";
import domain from "./modules/shared/domain";
import generics from "./modules/shared/generics";
import sidebarActiveMenu from "./modules/shared/sidebarActiveMenu";
import informationModal from "./modules/shared/informationModal";
import planning from "./modules/b2b/planning";
import notifications from "./modules/shared/notifications";
import renderGetApi from "./modules/shared/renderGetApi";
import activeReception from "./modules/b2b/activeReception";
import strema from "./modules/b2b/strema";
import dashboard from "./modules/b2b/dashboard";
import speechRecognition from "./modules/shared/speechRecognition";
import tutorials from "./modules/b2b/tutorials";
import requestManager from "./modules/shared/requestManager";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        talkjs,
        vehicleIdentification,
        budget,
        techInfo,
        loadings,
        tyres,
        customer,
        backofficeEntities,
        domain,
        generics,
        backofficeModulesDropdown,
        sidebarActiveMenu,
        backofficeScheduling,
        backofficeCalendarHoursDropdown,
        informationModal,
        backofficeLastUser,
        planning,
        notifications,
        renderGetApi,
        activeReception,
        strema,
        dashboard,
        backofficeNavigation,
        speechRecognition,
        tutorials,
        requestManager,
    },

    state: {
        showSideBar: false,
    },

    mutations: {
        toggleSidebar(state) {
            state.showSideBar = !state.showSideBar;
        },
    },
});
